import { render } from "./ClassesPage.vue?vue&type=template&id=6dadc2c7&scoped=true"
import script from "./ClassesPage.vue?vue&type=script&lang=js"
export * from "./ClassesPage.vue?vue&type=script&lang=js"

import "./ClassesPage.vue?vue&type=style&index=0&id=6dadc2c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dadc2c7"]])

export default __exports__